import { NgModule } from '@angular/core';

import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElSharedModule } from '../shared/shared.module';
import { ElInputModule } from '../input/input.module';
import { ElCardModule } from '../card/card.module';
import { ElCheckboxModule } from '../checkbox/checkbox.module';
import { ElButtonModule } from '../button/button.module';
import { ElSelectComponent, ElSelectLabelComponent } from './select.component';
import { ElOptionComponent } from './option.component';
import { ElOptionGroupComponent } from './option-group.component';
import { ElIconModule } from '../icon/icon.module';

const EL_SELECT_COMPONENTS = [
  ElSelectComponent,
  ElOptionComponent,
  ElOptionGroupComponent,
  ElSelectLabelComponent,
];

@NgModule({
  imports: [
    ElSharedModule,
    ElOverlayModule,
    ElButtonModule,
    ElInputModule,
    ElCardModule,
    ElCheckboxModule,
    ElIconModule,
  ],
  exports: [...EL_SELECT_COMPONENTS],
  declarations: [...EL_SELECT_COMPONENTS],
})
export class ElSelectModule {
}
